module.exports = __webpack_public_path__ + "img/red.37be4d5b.png";